import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { JSErrors } from '@newrelic/browser-agent/features/jserrors';

const applicationID = process.env.REACT_APP_NR_APPLICATION_ID
const licenseKey =  process.env.REACT_APP_NR_LICENSE_KEY
const trustKey = process.env.REACT_APP_NR_TRUST_KEY


const options = {
  init: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    applicationID: applicationID
  },
  info: {
    licenseKey: licenseKey,
    applicationID: applicationID,
    agent: applicationID,
    trustKey: trustKey
  },
  loader_config: {
    accountID: trustKey,
    trustKey: trustKey,
    agentID: applicationID,
    licenseKey: licenseKey,
    applicationID: applicationID
  },
  features: [
    JSErrors
  ],
}

const agent = new BrowserAgent(options);

export default agent